import { endPoint } from './base.config';

export const fikenApi = {
  getbankAccounts: `${endPoint}3rd/fiken/:companySlug/get-bank-accounts`,
  getContacts: `${endPoint}3rd/fiken/:companySlug/get-contacts`,
  getAccounts: `${endPoint}3rd/fiken/:companySlug/accounts`,
};
